import { Typography } from '@mui/material';
import { useAppSelector } from 'app/hooks';

import { disciplinaInfoSelector } from '#modules/disciplinas/redux/disciplinaInfoSlice';

import { BoxInfo } from './styles';

export function PlanoEnsinoIntegracao() {
  const disciplina = useAppSelector(disciplinaInfoSelector.disciplina);

  if (disciplina == null) return <></>;

  return (
    <BoxInfo id="integracao">
      <header>
        <Typography>INTEGRAÇÃO COM A FILOSOFIA INSTITUCIONAL</Typography>
      </header>

      <div>
        <Typography>{disciplina.integracao}</Typography>
      </div>
    </BoxInfo>
  );
}
